import config from '../../constants/config';
import { getCleanUsername } from '../helpers/utils';

export default {
  and: 'ja',
  SignUp: 'Rekisteröidy mukaan',
  LogIn: 'Kirjaudu sisään',
  LOGIN: 'KIRJAUDU SISÄÄN',
  Close: 'Sulje',
  Ok: 'OK',
  Back: 'Takaisin',
  He: 'Hän',
  She: 'Hän',
  Him: 'Hän',
  Her: 'Hän',
  Find: 'Etsi',
  Thanks: 'Kiitos',
  SingUpLanding: 'Paina tästä ja etsi',
  LogInLanding: 'Oletko jo jäsen? Kirjaudu sisään tästä',
  TitleLanding: 'Väsynyt vanhoihin deittisivustoihin?',
  SubTitleLanding:
    'Niin olemme mekin! Löydä uusia kokemuksia täällä ' +
    config.TITLE +
    ' esimerkiksi näillä palveluilla:',
  logInWithApple: 'Kirjaudu sisään Applella',
  mailIsConfirmed:
    'Onnittelut! Tilisi on aktivoitu onnistuneesti. Kiitos sähköpostisi vahvistamisesta. Voit nyt nauttia täydestä pääsystä palveluihimme.',
  SignUpWithEmail: 'Kirjaudu sähköpostilla',
  reactivateAccount: 'Aktivoi tili uudelleen',
  welcomeBack: 'Tervetuloa takaisin',
  prevYouDeactivYourAcc: 'Olet asettanut tilisi ei-aktiiviseen tilaan',
  doUwantToReacYourAcc: 'Haluatko aktivoida tilisi uudelleen',
  yesReactivateMyAcc: 'Kyllä, aktivoi tilini uudelleen',
  noKeepDeactivated: 'Ei, pidä tili ei-aktiivisena',
  signUpWithApple: 'Kirjaudu Applella',
  TermsOfService: 'Käyttö\u00A0of\u00A0Ehdot',
  PrivacyPolicy: 'Tietosuoja\u00A0käytöntö',
  JoinToday: 'Liity Tänään',
  firstName: 'Etunimi',
  yourFirstName: 'Kerro meille etunimesi',
  EmailAddress: 'Sähköpostiosoite',
  password: 'Salasana',
  EnterEmailAddress: 'Syötä sähköpostiosoite',
  EnterPassword: 'Syötä salasana',
  PleaseEnterValidEmail: 'Syötä oikea sähköpostiosoite',
  PleaseEnterPassword: 'Ole hyvä ja syötä salasana',
  LandPageHeader: 'Valmis uuteen seikkailuun?',
  LandPageSubHeader:
    config.NICHE_SINGULAR.replace(/\w/, (c) => c.toUpperCase()) +
    ' Deittikontaktit ' +
    config.NICHE_SINGULAR +
    ' sinkut etsii romanssia',
  LandPageLegal: 'Kirjautumalla sisään, hyväksyt meidän',
  LandPageAllDevices: 'Saatavilla kaikissa laitteissa',
  ForgotYourPassword: 'Unohditko salasanasi?',
  or: 'tai',
  Save: 'Tallenna',
  views: 'Katseluita',
  view: 'Katselu',
  ViewedMyProfile: 'Katsoi profiiliani',
  ViewProfile: 'Katso profiili',
  UnmatchDelete: 'Peruuta osuma / Poista',
  UnmatchDeleteQuestionMark: 'Peruuta osuma/Poista?',
  UnmatchDeleteText:
    'Oletko varma että haluat Peruuttaa osuman/Poistaa? Sinulla ei ole tämän jälkeen pääsyä chattihistoriaan ',
  YesUnmatchDelete: 'Kyllä, Peruuta osuma/Poista',
  IViewed: 'Minä katsoin',
  ViewedMe: 'Katsoi minua',
  LikesMe: 'Tykkää minusta',
  Mutual: 'Yhteinen',
  MyLikes: 'Minun tykkäykset',
  Chat: 'Chatti',
  Flirts: 'Flirtit',
  Send: 'Lähetä',
  typing: 'kirjoittaa',
  UpgradeToVIP: 'Korota VIP jäsenyyteen',
  TypeAMessageHere: 'Kirjoita viesti tähän',
  FeaturesChat:
    config.NICHE_SINGULAR.replace(/\b\w/g, (c) => c.toUpperCase()) + ' Chatti',
  SendMessagesToWhoYouWant: 'Lähetä viestejä kenelle haluat',
  SeeWhoIsInterestedInYou: 'Katso kuka on kiinnostunut sinusta',
  SeeWhoIsReallyInterestedInYou: 'Katso kuka on todella kiinnostunut sinusta',
  IncreaseYourChancesWithAFlirt: 'Paranna mahdollisuuksiasi Flirtillä',
  GetDatesFast: 'Saa treffejä vastaamalla Kyllä tai Ei',
  FeaturesIncluded: 'Palvelut sisältävät',
  Matches: 'Osumat',
  Likes: 'Tykkäykset',
  QuickMatch: 'Nopea Osuma',
  Search: 'Haku',
  Favorite: 'Suosikki',
  Favorites: 'Suosikit',
  Browse: 'Selaa',
  MyProfile: 'Minun profiili',
  Settings: 'Asetukset',
  // Logout
  LogoutH1: 'Olet kirjautunut ulos onnistuneesti',
  LogoutP: 'Sinua tullaan kaipaamaan...',
  LogoutButton: 'Kirjaudu sisään uudelleen',
  // Unsubscribe
  tooManyEmails: 'Liian monia sähköposteja',
  enterYourEmailBelowToUnsub: 'Syötä sähköpostisi alle peruuttaaksesi tilaus',
  unsubscribe: 'Peruuta tilaus',
  unsubscribeSuccess: 'Tilauksen peruutus onnistui',
  youWillNoLongerReceiveAnyEmailFromUs:
    'Et tule enää vastaanottamaan sähköposteja meiltä',
  unSubByAccident: 'Tilaus peruutettu vahingossa',
  reSubHere: 'Tilaa uudelleen tästä',
  helpUsGetBetter: 'Auta meitä parantamaan palveluamme',
  tellUsWhyYouUnSub: 'Kerro meille miksi peruutit tilauksen',
  resubscribeSuccessful: 'Tilaus onnistui',
  clickHere: 'Klikkaa tästä',
  toGoBackToTheSite: 'palataksesi takaisin sivustolle',
  pleaseSelectOneOfTheReasonsBelow: 'Ole hyvä ja valitse syy alta',
  notEnoughUsers: 'Ei tarpeeksi käyttäjiä',
  complicatedToUse: 'Monimutkainen käyttää',
  notEnoughOptions: 'Ei tarpeeksi vaihtoehtoja',
  betterAlternatives: 'Parempia vaihtoehtoja',
  badExperienceWithAnotherUser: 'Huono kokemus toisen käyttäjän kanssa',
  technicalIssues: 'Tekniset ongelmat',
  thanksForYourFeedback: 'Kiitos palautteestasi',
  tapHere: 'Paina tästä',
  // Who's online
  WhosOnline: 'Kuka on kirjautuneena',
  Recent: 'Viimeaikainen',
  ThisWeek: 'Tällä viikolla',
  MembsWereOnlineRec: 'Jäsenet jotka kirjautuneena lähiaikoina',
  MembsWereOnlineWeek: 'Käyttäjät kirjautuneena tällä viikolla',
  MembsRecWillAppHere: 'Käyttäjät paikalla viimeaikoina näkyvät täällä',
  MembsThisWeekWillAppHere:
    'Käyttäjät kirjautuneena tällä viikolla näkyvät täällä',
  // Browse
  BrowseZero: 'Täällä on',
  BrowseZero2: 'Käyttäjää',
  BrowseMembersAppear: 'Käyttäjät näkyvät täällä',
  // Favorites
  MyFavorites: 'Minun Suosikit',
  FavoritedMe: 'Merkitsi minut suosikiksi',
  YourFavWillAppHere: 'Suosikkisi näkyvät täällä',
  MembHaveFavU: 'Käyttäjät ovat merkinneet sinut suosikiksi',
  MembWhoFavU: 'Käyttäjät joiden suosikki olet näkyvät täällä',
  NewPasswordSet: 'Uusi salasana asetettu. Voit nyt kirjautua sisään.',
  // Password Recovery
  recoveryTittle: 'Salasanan palautus',
  recoveryButton: 'Palauta salasana',
  goBackToLogIn: 'Takaisin kirjautumissivulle',
  recoveryMessage1:
    'Jos löydämme käyttäjätilin tällä sähköpostilla, lähetämme viestin salasanan palautukseen.',
  NewPassword: 'Uusi Salasana',
  SetNewPassword: 'Aseta uusi salasana',
  // Info Line
  NotShared: 'Ei jaettu',
  // Create Account Email Register
  byCreatingYourAccount: 'Liittymällä sivustolle, hyväksyn käyttöehdot ',
  alsoAgree:
    'Hyväksyn myös vastaanottavani viestejä, tilipäivityksiä & erikoistarjouksia sähköpostitse',
  picturesDisclaimer:
    'Kuvia käytetään vain havainnollistamistarkoituksiin, ja kaikki Sisällössä kuvatut henkilöt ovat malleja',
  step: 'Askel',
  // GenderStep
  StepsTitle:
    'Liity meihin & Tapaa ' +
    (config.NICHE_SINGLES
      ? config.NICHE_SINGLES
      : config.NICHE_PLURAL.replace(/\b\w/g, (c) => c.toUpperCase())) +
    ' Nyt!',
  gender: 'Sukupuoli',
  startMeeting: 'Aloita tapailu nyt',
  weNeedInfo: 'Tarvitsemme vain muutaman tiedon',
  iAm: 'Minä olen:',
  near: 'Lähellä:',
  seeking: 'Etsin:',
  next: 'Seuraava',
  viewOtherOptions: 'Näe muut vaihtoehdot',
  // LocationStep
  location: 'Paikka',
  WhereAreYouLocated: 'Millä paikkakunnalla asut?',
  WellFindMatchesInYourArea: 'Etsimme sinulle osumia alueeltasi',
  EnterYourCityOrLocation: 'Syltä kaupunki tai paikkakunta:',
  // AgeStep
  age: 'Ikä',
  howOldAreYou: 'Kuinka vanha olet?',
  enterAgeBelow: 'Syötä ikäsi alapuolelle',
  ageLabel: 'Ikä:',
  agePlaceholder: 'Ikäsi',
  ageError: 'Iän tulee olla välillä < ja >',
  EnterYourAge: 'Syötä ikäsi:',
  // UsernameStep
  username: 'Käyttäjänimi',
  chooseUsername: 'Valitse käyttäjänimi',
  itWillBeYourBio: 'Sitä käytetään käyttäjäprofiilisi kuvauksessa',
  usernamePlaceholder:
    'Esimerkiksi: ' + getCleanUsername(config.NICHE_SINGULAR),
  chooseAUsername: 'Valitse käyttäjänimi',
  usernameError: 'Tämä käyttäjänimi on virheellinen',
  usernameLabel: 'Käyttäjänimi',
  usernameLabelSmall: '(6-14 Kirjaimet & Numerot)',
  // EmailStep
  emailPassword: 'Sähköposti/Salasana',
  youAreDone: 'Olet melkein valmis...',
  createYourAccount: 'Luo tilisi alla',
  createAccount: 'Luo tili',
  emailError: 'Ole hyvä ja syötä oikea sähköpostiosoite',
  passwordError: 'Salasanan tulee olla vähintään 6 merkkiä pitkä',
  ageMissingHeadline: 'Ikä pyyntö',
  EnterYourEmailAddress: 'Syötä sähköpostisi',
  RemainsConfidential: '(pidetään suojattuna)',
  ChooseAPassword: 'Valitse salasana',
  Min6Car: '(vähintään 6 merkkiä)',
  itWiilBeUsedForLogin: 'Sitä käytetään kirjautumiseen',
  // PasswordStep
  choosePassword: 'Valitse salasana',
  // EmailAndPasswordStep
  enterEmailAndPassword: 'Kirjoita sähköpostiosoitteesi ja valitse Salasana',
  // Auto-complete
  EnterYourLocation: 'Syötä paikkakuntasi',
  EnterYourCityOrZipCode: 'Syötä kaupunkisi tai postinumerosi alle:',
  enterCityOrZip: 'Syötä kaupunkisi tai postinumerosi:',
  Menu: 'Valikko',
  More: 'Lisää',
  // Matches
  noMatchesFound: 'Ei osumia',
  wantMoreMatches: 'Haluatko enemmän osumia?',
  tapButtonBelow: 'Paina nappia alta ja muokkaa hakukriteereitäsi',
  editMatchPreferences: 'Muokkaa hakuukriteereitä',
  // MyLikes
  youHave: 'Sinulla on',
  increaseYourMatches:
    'Paranna mahdollisuuksiasi painamalla "Aloita Tykkääminen" nappia alla',
  startLiking: 'Aloita Tykkääminen',
  // Mutual
  mutualLikes: 'Yhteiset tykkkäykset',
  // LikesMe
  membersHaveLikedYou: 'Käyttäjät jotka ovat tykänneet sinusta',
  // MyViews
  youHaveViewed: 'Olet vieraillut',
  profiles: 'Profiilit',
  membersWhoYouViewed:
    'Käyttäjät joiden profiilissa olet vieraillut näkyvät täällä',
  // ViewedMe
  memberViewedYou: 'Käyttäjät jotka vieraili profiilissasi',
  memberWhoViewYourProfile:
    'Käyttäjä joka vierailee profiilissasi näkyy täällä',
  // Settings
  logout: 'Kirjaudu Ulos',
  general: 'yleinen',
  account: 'tili',
  legal: 'laillinen',
  support: 'tuki',
  matchPref: 'Osuma mieltymykset',
  emailPref: 'Sähköposti mieltymykset',
  privacyStgs: 'Yksityisyys asetukset',
  reactivateVipMbership: 'Aktivoi uudelleen VIP jäsenyys',
  youAreVipMember: 'Sinä olet VIP jäsen',
  byCancelingYourVip:
    'Peruuttamalla VIP jäsenyytesi, sinulla ei ole enää pääsyä seuraaviin palveluihin kun voimassa oleva jäsenyytesi kuluu loppuun',
  unLimitedMessages: 'Rajattomat Viestit',
  seeAllPhotos: 'Näe kaikki kuvat',
  unlimtedUndo: 'Rajattomat peruutukset',
  deactivateAccount: 'Aseta tili ei-aktiiviseksi',
  deleteAccount: 'Poista tili',
  showMe: 'Näytä minulle',
  limitSearchToDistance: 'Rajoita hakua etäisyyden perusteella',
  showAges: 'Näytä ikävaihtoehdot',
  men: 'Miehet',
  women: 'Naiset',
  toastPrefUpdatedSucc: 'Mieltymykset päivitetty onnistuneesti',
  receiveEmail: 'Vastaanota sähköpostia',
  whenSomebodySendsNewMsg: 'Kun joku lähettää minulle uuden viestin',
  whenSomebodyLikesMe: 'Kun joku pitää minusta',
  whenSomebodyVisitMyPof: 'Kun joku vierailee profiilissani',
  whenNewMembersComeOnline: 'Kun uusia jäseniä kirjautuu palveluun',
  withDiscountPromotions: 'Alennukset ja tarjoukset',
  notifOptions: 'Ilmoitus vaihtoehdot',
  notifUpdateSucc: 'Ilmoitukset päivitetty onnistuneesti',
  privacySettingsText1: 'Hallinnoi kuka näkee profiilisi',
  privacySettingsText2: 'Valitse yksi tai useampi vaihtoehto alta',
  importantNotice: 'Tärkeä tiedotus',
  byDeactivatingYourAccount:
    'Asettamalla tilisi ei-aktiiviseen tilaan sinulla ei ole pääsyä seuraaviin palveluihin ennen kuin aktivoit tilisi uudelleen',
  yourMatches: 'Sinun osumasi',
  yourMessages: 'Sinun viestisi',
  yourLikes: 'Sinun tykkäykset',
  yourFavorites: 'Sinun suosikit',
  allOtherInfo: 'Kaikki muu tieto koskien tiliäsi',
  yourProfileWillBeHidden:
    'Profiilisi piilotetaan muilta jäseniltä. Et tule vastaanottamaan sähköposteja meiltä ennen kuin aktivoit tilisi uudelleen. Näpäytä nappia alla asettaaksesi tilisi ei aktiiviseen tilaan',
  areYouSure: 'Oletko varma',
  yourAccountWillBeDeact: 'Tilisi asetetaan ei-aktiiviseen tilaan',
  yesDeactivateAcc: 'Kyllä, aseta ei-aktiiviseksi',
  accountSuccDeact: 'Tili onnistuneesti asetettu ei-aktiiviseksi',
  byDeletingYourAccount:
    'Poistamalla tilisi seuraavat tiedot poistetaan pysyvästi',
  infoUsedToCreate: 'Tiedot joita käytettiin tilin luomiseen',
  yourPhotos: 'Sinun kuvasi',
  yourChatHistory: 'Sinun chattihistoriasi',
  thisActionIsNotReversible: 'Tätä toimintoa ei voi perua',
  tapTheButtonBellow: 'Näpäytä alla olevaa nappia poistaaksesi tilisi',
  yesDeleteAccount: 'Kyllä, poista tilini',
  accountSuccDelete: 'Tili onnistuneesti poistettu',
  byReactivatingYourVip:
    'Aktivoimalla VIP jäsenyytesi tilauksen uudelleen sinua laskutetaan uudelleen meneillä olevan laskutuskauden päätyttyä',
  tapTheButtonToReactivateVip:
    'Näpäytä alla olevaa nappia aktivoidaksesi VIP jäsenyys uudelleen',
  yourMembershipWillExpire: 'Jäsenyytesi vanhenee',
  yourMembershpWillRenew: 'Jäsenyytesi uusiutuu',
  yourVipMembershipWillReactivate: 'Sinun VIP jäsenyys aktivoidaan uudelleen',
  yesReactivateVip: 'Kyllä, aktivoi VIP jäsenyys uudelleen',
  noIveChangedMyMind: 'Ei, muutin mieltäni',
  membershipSuccessfullyReactivated:
    'Jäsenyys aktivoitu uudelleen onnistuneesti',
  membershipSuccessfullyCanceled: 'Jäsenyys peruutettu onnistuneesti',
  visibilityPreferences: 'Näkyvyys mieltymykset',
  onlyShowMyProfileToPeopleISendMsg:
    'Näytä profiilisi vain ihmisille joille lähetän viestejä',
  dataManagement: 'Data hallinta',
  tapTheDownloadDataButtonBelowToViewYourAccountData:
    'Paina "Tulosta Data" nappia alta nähdäksesi tilisi tiedot',
  downloadData: 'Tulosta Data',
  yesDownload: 'Kyllä, lataa',
  yourDataWillBeDownloaded: 'Tietosi ladataan',
  changePassword: 'Vaihda salasanaa',
  saveChanges: 'Tallenna muutokset',
  currentPassword: 'Nykyinen salasana',
  confirmNewPassword: 'Vahvista uusi salasana',
  enterNewPassword: 'Syötä uusi salasana',
  passwordNotMatch: 'Salasana ei täsmää',
  passwordChangedSuccess: 'Salasana vaihdettu onnistuneesti',
  // Member
  registredAs: 'Rekisteröity:',
  userID: 'Käyttäjätunnus:',
  version: 'Versio:',
  cancel: 'Peruuta',
  reportUser: 'Raportoi käyttäjä',
  blockUser: 'Estä käyttäjä',
  options: 'Vaihtoehdot',
  startConversation: 'Aloita keskustelu',
  requestPhotoTap: 'Paina tästä',
  requestPhotoTapTo: 'pyytääksesi hänen kuvaansa',
  requestPhotoTapToFemale: 'pyytääksesi hänen kuvaansa',
  requestPhoto: 'pyytääksesi kuvaa',
  photoAlreadyRequested: 'Kuvaa on jo pyydetty',
  youAlreadyRequestedPhoto: 'Olet jo pyytänyt kuvaa tältä käyttäjältä',
  photoRequestSuccessfully: 'Kuvapyyntö onnistui',
  tellWhy: 'Kerro meille miksi',
  inappropriatePhotos: 'Asiattomat kuvat',
  inappropriateMessages: 'Asiattomat viestit',
  badOfflineBehavior: 'Huono käytös netin ulkopuolella',
  feelsLikeSpam: 'Tuntuu spammaukselta',
  other: 'Muu',
  report: 'Raportoi',
  reportComment: 'Raportoi kommentti...',
  blockMember: 'Estä käyttäjä?',
  willNoLongerAppear: 'ei enää ilmesty osumiesi listalle.',
  yesBlock: 'Kyllä, estä käyttäjä',
  noCancel: 'Ei, peruuta',
  userReportedSuccessfully: 'Käyttäjä raportoitu onnistuneesti',
  userBlockedSuccessfully: 'Käyttäjä estetty onnistuneesti',
  addedToFavorites: 'Lisätty suosikkien listalle!',
  removedFromFavorites: 'Poistettu suosikeista!',
  sendAMessage: 'Lähetä viesti',
  sendUserAMessage: 'Lähetä {user} viesti',
  wellYouveComeThisFar:
    'Olet edennyt näin pitkälle, voit ihan yhtä hyvin sanoakin jotakin',
  chatWith: 'Chattaa',
  outOfFlirts: 'Ei flirttejä jäljellä',
  untilYouCanSend: 'Ennen kuin voit lähettää flirttejä uudelleen.',
  wantToMakeSure: 'Haluatko varmistaa että',
  seesYou: 'näkee sinut?',
  goVipGetFlirts: 'Ole VIP ja saa {num_of_flirts} flirttiä päivässä!',
  getMoreFlirts: 'Saa enemmän flirttejä',
  noNotThisTime: 'Ei, ei tällä kertaa',
  flirtSent: 'Flirtti lähetetty ja tykätty',
  memberNotSharedAboutMe: 'Tämä jäsen ei ole täyttänyt Tietoa Minusta osiotaan',
  dontWait: 'Älä odota',
  chooseFlirt: 'Valitse flirtti:',
  sendFlirt: 'Lähetä flirtti',
  flirtIsSent: 'Flirtti on lähetetty',
  // Chats
  chats: 'Chatit',
  sentMessages: 'Lähetetyt viestit',
  yourConversations: 'Keskustelusi muiden jäsenten kanssa näkyvät täällä',
  yourSentMessages: 'Lähettämäsi viestit muille käyttäjille näkyvät täällä',
  // ChatRoom
  cannotSendMessageUnlessVip:
    "Et voi lähettää chattiviestejä jollet ole Vip käyttäjä tai 'Happy Hour' on käynnissä",
  happyHour: 'Happy Hour',
  sendMessagesFree: 'Lähetä viestejä ilmaiseksi',
  endsIn: 'Loppuu:',
  happyHourTonightAt: 'Tänään illalla kello ',
  happyHourTodayAt: 'Tänään kello ',
  // Contact us
  ContactUs: 'Ota\u00A0Yhteyttä',
  ContactUsSupport: 'Ota yhteyttä / Asiakaspalvelu',
  WhatIsYourEmail: 'Mikä on sähköpostiosoitteesi?',
  HowCanWeHelpU: 'Kuinka voimme auttaa sinua?',
  WriteMsg: 'Kirjoita viesti...',
  SendMsg: 'Lähetä viesti',
  EnterMsg: 'Syötä viesti.',
  AlertMsgSentSuccessfully: 'Kiitos! Viesti lähetetty onnistuneesti.',
  ToastMsgSentSuccessfully: 'Viesti lähetetty onnistuneesti',
  Subject: 'Aihe',
  subject0: 'Yleinen ongelma',
  subject1: 'VIP Jäsenyys',
  subject2: 'Ilmoita huijauksesta',
  subject3: 'Peruutus',
  subject4: 'Poista tili',
  subject5: 'Muu',
  // Search
  refineSearch: 'Tarkenna hakua',
  iamDoneRefining: 'Tarkennus on valmis',
  showAdvanced: 'Näytä laajennetut vaihtoehdot',
  hideAdvanced: 'Piilota laajennetut vaihtoehdot',
  cancelSearch: 'Peruuta hakutarkennus?',
  youWillLoseYourChanges: 'Menetät kaikki muutoksesi hakukriteereissäsi',
  yesLeavePage: 'Kyllä, lähde sivulta',
  noContinueRefining: 'Ei, jatka tarkennusta',
  zeroMembersFound: 'Jäseniä löytynyt',
  tap: 'Näpäytä',
  // tapHere: 'Tap Here',
  // uploadAPhotoHere: 'Upload a photo here',
  toDisplayPreviousMembers: 'nähdäksesi menneet käyttäjät.',
  toEditCurrentFilters: 'muokataksesi nykyisiä filttereitäsi.',
  resetSearch: 'Päivitä Haku',
  tryAgain: 'Yritä uudelleen',
  mile: 'Maili',
  miles: 'Mailia',
  noUsers: 'Ei käyttäjiä',
  // Quick Match Button text
  undo: 'Peruuta',
  pass: 'Jätä välistä',
  like: 'Tykkää',
  profile: 'Profiili',
  undoNotAvailable: 'Peruutus ei saatavilla',
  nothingToUndo: 'Mitään peruutettavaa ei löytynyt.',
  thisIsTheFirstUser: 'Tämä on ensimmäinen käyttäjä.',
  dismissAd: 'Sulje',
  seeMoreHere: 'Näe lisää täällä',
  tryChangingYourPreferences: 'Kokeile muokata mieltymyksiäsi.',
  errorOnInviteActionTitle: 'Virhe Pikaosumassa',
  // It's Match
  itsMutual: 'Se on molemminpuolista',
  youAndMemberLikeEachOther: 'Sinä ja {member} tykkäätte toisistanne!',
  seeMoreMatches: 'Näe enemmän Osumia',
  // My Profile
  edit: 'Muokkaa',
  aboutMe: 'Tietoa minusta',
  youHaveNotSharedAbout: 'Et ole täyttänyt Tietoa Minusta osiota vielä',
  appearance: 'Ulkonäkö',
  situation: 'Tilanne',
  addPhoto: 'Lisää Profiilikuva',
  // Edit Profile
  editProfile: 'Muokkaa Profiilia',
  reset: 'Päivitä',
  dob: 'Syntymäpäivä',
  youWillLoseYourChangesProfile:
    'Menetät kaikki nykyiset muutokset joita olet tehnyt profiilissasi',
  cancelEdit: 'Peruuta profiilin muokkaus?',
  noContinueEditing: 'Ei, jatka muokkausta',
  invalidMonth: 'Virheellinen kuukausi',
  invalidDay: 'Virheellinen päivä',
  invalidAge: 'Sinun tulee olla välillä {min} ja {max} vuotta',
  invalidFebruar: 'Helmikuussa on korkeintaan 28 tai 29 päivää',
  invalid30Day: 'Tässä kuussa on korkeintaan 30 päivää',
  invalid31Day: 'Tässä kuussa on korkeintaan 31 päivää',
  invalidLocation:
    'Paikkakunta on virheellinen, ole hyvä ja valitse paikkakunta valikosta',
  locationUpdated: 'Paikkakunta onnistuneesti päivitetty',
  setAsMainPhoto: 'Aseta ensisijaiseksi kuvaksi',
  changeAsMainPhoto: 'Aseta ensisijaiseksi kuvaksi',
  deletePhoto: 'Poista kuva',
  areSureDeletePhoto: 'Oletko varma että haluat poistaa tämän kuvan?',
  noKeepPhoto: 'Ei, pidä kuva',
  yesDeletePhoto: 'Kyllä, poista kuva',
  editPhoto: 'Muokkaa kuvaa',
  profileUpdated: 'Profiili päivitetty onnistuneesti',
  secondaryImageAlertText:
    'Tämä kuva on merkitty toissijaiseksi asiakaspalvelumme taholta ja sitä ei siksi voi käyttää ensisijaisena kuvana.',
  reviewImageAlertText:
    'Tämä kuva ei ole hyväksytty asiakaspalvelun taholta, ole hyvä ja yritä myöhemmin uudelleen.',
  pendingReview: 'Odottaa tarkastusta',
  // missing location
  locationReq: 'Paikkakunta Pyyntö',
  pleaseEnterLocation: 'Ole hyvä ja syötä paikkakuntasi alle.',
  withoutItOther: 'Ilman sitä, muut käyttäjät',
  cantSee: 'en näe,',
  likeOrMessage: 'tykkää, tai viestittää sinulle.',
  submit: 'Lähetä',
  // missing username
  completeYourProfile: 'Täytä profiilisi tiedot',
  itWillBeUsedOnYourProfileBio: 'Sitä käytetään profiilisi kuvauksessa',
  userNameLettersAndNumbers: '(6-14 merkkiä ja numeroita)',
  submitUsername: 'Lisää Käyttäjänimi',
  unknownError: 'Tuntematon virhe tapahtui',
  confirmUsername: 'Valitse käyttäjänimi',
  orChooseNewOne: 'tai valitse uusi.',
  // missing username and location
  welcomeToSite: 'Tervetuloa ' + config.TITLE,
  yourAccountIsNowActive: 'Tilisi on nyt aktiivinen!',
  itsGreatToHaveYou:
    'On hienoa, että olet täällä sivuston jäsenenä ja odotamme saavamme auttaa sinua löytämään täydellisen\u00A0osuman.',
  // error
  somethingWentWrong: 'Jokin meni pieleen',
  networkError: 'Verkosto virhe',
  // invalid Token
  invalidToken: 'Virheellinen merkki. Ole hyvä ja kirjaudu uudelleen',
  // rejected Username
  rejectedUsername: 'Hylätty käyttäjänimi',
  // missing password
  missingPassword: 'Olet melkein valmis...',
  missingPasswordText: 'Aseta salasanasi alla',
  missingPasswordPlaceholder: 'vähintään 6 merkkiä',
  submitPassword: 'Aseta Salasana',
  // missing email
  missingEmail: 'Meillä ei ole sinun sähköpostiasi',
  missingEmailText:
    'Syötä sähköpostiosoitteesi alle niin saat ilmoituksia kun vastaanotat viestejä, tykkäyksiä, osumia, ja kun ihmiset vierailevat profiilissasi.',
  submitEmail: 'Lisää Sähköposti',
  // Move and Scale
  moveAndScale: 'Siirrä ja Muokkaa',
  crop: 'Leikkaa',
  uploadError: 'Virhe Kuvan Latauksessa',
  whoops: 'Hupsista',
  itSeemsThatIsTaking:
    'Näyttää siltä että kuvan lataamisessa menee normaalia kauemmin. Ole hyvä ja yritä uudelleen.',
  // Missing Photo
  photoRequest: 'Kuvapyyntö',
  wait: 'Odota...',
  yourMissingPhoto: 'Sinulta puuttuu kuva',
  membersWithoutPhotos: 'Käyttäjät ilman kuvia saavat 65% vähemmän',
  likelyToReceive: 'tykkäyksiä ja viestejä',
  submitPhoto: 'Lataa Kuva',
  takePhoto: 'Ota Kuva',
  chooseFromLibrary: 'Valitse Kuva Arkistosta',
  // Missing Gender
  youLookingFor: 'Mitä olet etsimässä',
  // Explicit Opt in Modal
  youAreAlmostDone: 'Olet lähes valmis',
  iWouldLikeToGetSpecOffers:
    'Haluan saada erikoistarjouksia, erinomaisia alennuksia, ja kuukasikirjeen sähköpostitse',
  iHaveReadAndAgreeToPP: 'Olen lukenut ja hyväksyn käyttöehdot',
  ByJoiningTheSiteAgreeTos: 'Liittymällä sivustolle, hyväksyn',
  optional: 'Vaihtoehtoinen',
  required: 'Tarvitaan',
  continue: 'Jatka',
  // coreg
  toGetStarted: 'Aloittaaksesi',
  tapHereToGetStarted: 'Paina tästä aloittaaksesi',
  hello: 'Hei',
  // Upgrade Modal
  membershipStatus: 'Jäsenyyden Tila',
  upgradeToVipChoosePlan: 'Korota VIP jäsenyyteen.',
  wantUnlimitedMessages: 'Haluatko rajattomasti viestejä?',
  wantToReply: 'Haluatko vastata %gender%? Ole VIP!',
  getUnlimitedMessages: 'Saa rajattomasti viestejä. Valitse jäsenyys:',
  needToUndoMistake: 'Haluatko peruuttaa virheellisen toiminnon? Ole VIP!',
  getUnlimitedUndos:
    'Saa rajattomasti toiminnon peruutuksia - Valitse jäsenyys:',
  whoViewedYourProfile: 'Kuka vieraili profiilissasi? Ota selvää!',
  peopleViewedYourProfile: 'Profiilissasi vierailleet ihmiset',
  chooseVipPlanToSeeThem: 'Valitse VIP jäsenyys ja näe heidät:',
  wantToSeeWhoFavoritedYou: 'Haluatko nähdä kuka merkkasi sinut suosikikseen?',
  peopleFavoritedYou: 'Sinut suosikiksi merkanneet',
  wantToSeeWhoLikesYou: 'Haluatko nähdä kuka tykkää sinusta?',
  peopleLikedYou: 'Sinusta tykänneet',
  youAreBasic: 'Olet perustason jäsen',
  wantToUnlockPhotos: 'Haluatko nähdä kaikki kuvat?',
  wantMoreFlirts: 'Haluatko 5 Flirttiä päivässä?',
  vipMembershipFeatures: 'VIP Premium jäsenyyden palvelut sisältävät:',
  vipMembershipFeaturesMobile: 'VIP Jäsenet vastaanottavat:',
  unlimited: 'Rajattomat',
  messaging: 'Viestit',
  meetSomeoneTonight: 'Korota nyt - Tapaa joku uusi tänä iltana!',
  chooseVipPlanBelow: 'Valitse VIP jäsenyys alta:',
  messagingSub: 'Jatka chattailua osumiesi kanssa',
  viewedSub: 'Näe kuka vieraili profiilissasi',
  likesMeSub: 'Ota selvää kuka tykkää profiilistasi',
  unlockPhotosSub: 'Näe kaikki käyttäjien kuvat',
  favoritedMeSub: 'Näe kuka on todella kiinnostunut sinusta',
  moreFlirtsSub: 'Paranna mahdollisuuksiasi 5 Flirtillä päivässä',
  goPrivateSub: 'Hallinnoi kuka näkee profiilisi',
  undoSub: 'Teitkö virheen? Peruuta valintasi!',
  select: 'Valitse',
  vipMembersReceive: 'VIP JÄSENET VASTAANOTTAVAT:',
  chooseYourPlan: 'VALITSE JÄSENYYTESI:',
  enterPaymentDetails: 'SYÖTÄ MAKSUTIETOSI:',
  creditCard: 'Luottokortti',
  yourSubscriptionWillRebill:
    'Tilauksesi veloitetaan automaattisesti {0} -jäsenyydestä {1} {2} ja uusitaan joka {0}, kunnes se peruutetaan. Voit peruuttaa tilauksesi milloin tahansa tilisi asetusten kautta. ',
  byTappingButtonBelow: 'Painamalla alla olevaa nappia, hyväksyt',
  andAuthorizeToCharge:
    'ja valtuutat meidät laskuttamaan sinun %CARD_TYPE% nyt ja joka kerta jäsenyyden uusiutuessa.',
  continueToPayPal: 'Jatka PayPal sivulle suorittaaksesi ostoksesi.',
  proceedToPayPal: 'Jatka PayPal sivulle',
  limitedTimeOffer: 'Rajoitetun ajan tarjous',
  promoHeader: '{date} VIP jäsenyys koeaika hintaan {price}',
  promoHeaderNoTrial: '{price} / {rebill_period} kuukausi/kuukaudet',
  promoSubHeaderText:
    'Tämä on ainutlaatuinen kertaluonteinen tarjous uusille jäsenille',
  promoButtonText: 'Vain {price} - {date} koeaika',
  promoRebillsText:
    '*Laskutetaan joka {date} hintaan {price} jos VIP jäsenyyttä ei peruuteta ennen koeajan loppumista*',
  accessToAllPhotos: 'Pääsy kaikkiin kuviin saatavilla',
  toPremiumUsers: 'Premium käyttäjille ainoastaan.',
  unlimitedMessaging: 'Rajattomat viestit saatavilla',
  upgradeTodayAndSendMessage:
    'Päivitä tänään lukeaksesi viestejä ja vastataksesi niihin',
  upgradeTodayAndSeePhotos:
    'Korota tänään ja saa pääsy kaikkiin kuviin käyttäjästä',
  mostPopular: 'Suosituimmat',
  notSuitableForCreditCard: 'Ei sovellu maksamaan luottokortilla?',
  weAreAccepting: 'Hyväksymme ',
  payPal: 'PayPal',
  // Welcome Back Modal
  weHaveAnOffer: 'Meillä on sinulle tarjous:',
  discount: 'alennus',
  onVipMembership: 'VIP -jäsenyydellä!',
  tapHereToSave: 'Napauta tästä säästääksesi 50%!',
  toUnlockFeatures: 'avatkasesi käyttöösi premium palvelut',
  upgrade: 'Korota',
  upgradeNow: 'Korota Nyt',
  // Invalid Tagline
  invalidTaglineHeadline: 'Kuvaus hylätty',
  invalidTaglineTitle:
    'Tekstiäsi sinun "Tietoa Minusta" osiossa ei hyväksytty.',
  invalidTaglineReason: 'Syy: ',
  invalidTaglineButton: 'Päivitä kuvaus',
  // Invalid Tagline
  photoRejectedHeadline: 'Kuva hylätty',
  photoRejectedTitle: 'Olemme pahoillamme...',
  photoRejectedParagraph: 'Yksi tai useampi ladatuista kuvistasi hylättiin.',
  photoRejectedReason: 'Syy: ',
  photoRejectedButton: 'Lataa Uusi Kuva',
  viewed: 'Katsottu',
  myProfile: 'Minun Profiilini',
  unlock: 'Avaa',
  allPhotos: 'Kaikki Kuvat',
  undos: 'Peruutukset',
  moreFlirts: 'Enemmän Flirttejä',
  goPrivate: 'Näy Yksityisenä',
  monthFor: 'Kuukausi',
  monthsFor: 'Kuukautta',
  mo: 'kk',
  month: 'kuukausi',
  months: 'kuukautta',
  monthly: 'kuukausittain',
  billed: 'laskutetaan',
  every: 'joka',
  saveUpTo: 'Säästä jopa',
  trialFor: 'Koeaika',
  day: 'päivä',
  days: 'Päivää',
  free: 'ilmainen',
  trialRebillsAt: 'koeaika laskutetaan',
  per: 'per',
  best: 'Paras',
  value: 'Arvo',
  // Checkout
  planSelected: 'Jäsenyys valittu',
  paymentOption: 'Maksuvaihtoehto',
  billingDetails: 'Laskutuksen yksityiskohdat',
  payByCard: 'Maksa kortilla',
  creditOrDebitCard: 'Maksa luotto- tai pankkikortilla',
  payWith: 'Maksutapa',
  pay: 'Pay',
  pal: 'Pal',
  for: 'hintaan',
  promoRebillsAt: 'tarjous uudelleenlaskutetaan hintaan',
  chooseMembershipPlan: 'Valitse jäsenyytesi alta',
  choosePaymentOption: 'Valitse maksutapasi alta',
  enterCardDetails: 'Syötä korttisi tiedot alle',
  nameOnCard: 'Nimi kortilla',
  enterFullName: 'Syötä koko nimi tähän',
  creditCardNumber: 'Luottokortin numero',
  cardNumber: 'Kortin numero',
  expirationDate: 'Viimeinen käyttöpäivä',
  cvv: 'CVV/Turvakoodi',
  pleaseEnterCvv: 'Syötä CVV',
  forYourPrivacyYouAreBilled:
    'Yksityisyytesi vuoksi sinua laskutetaan hienovaraisesti nimellä',
  byCompletingThisTransaction:
    'Suorittamalla tämän tapahtuman vakuutat olevasi vähintään 18 vuotta vanha ja että hyväksyt',
  submitAndUpgrade: 'Lähetä ja Korota VIP jäsenyyteen',
  thisIsSecurePage: 'Tämä on turvattu sivu.',
  dataTransferIsEncrypted: 'Datasiirto on kryptattu turvallisuuden vuoksi',
  tellUsYourFullName: 'Kerro meille koko nimesi (esim. Matti Meikäläinen)',
  pleaseEnterYourCreditCard: 'Ole hyvä ja syötä maksukorttisi numero',
  pleaseEnterValidCreditCard: 'Ole hyvä ja syötä oikea maksukortin numero',
  pleaseEnterMonth: 'Ole hyvä ja syötä kuukausi',
  pleaseEnterValidMonth: 'Ole hyvä ja syötä oikea kuukausi',
  pleaseEnterYear: 'Ole hyvä ja syötä vuosi',
  pleaseEnterValidCvv: 'Ole hyvä ja syötä oikea CVV',
  pleaseAgreeToTos: 'Ole hyvä ja hyväksy käyttöehtoihin',
  thanksForBeingVip: 'Kiitos että olet VIP jäsen',
  subscriptionUnavailable: 'Tilaus ei ole saatavilla koska olet jo VIP-jäsen',
  onTheBackOfCard: 'Maksukorttisi takapuolella voit',
  findYour: 'löytää sinun',
  cvvCvc: 'CVV/CVC',
  codeHere: 'koodi tähän.',
  hurryUp: 'Kiirehdi!',
  thisOfferExpires: 'Tämä tarjous päättyy:',
  youAreInLuck: 'Olet onnekas!',
  thisPromoGotExtended:
    'Tätä promoa on jatkettu. Tartu toimeen nopeasti, sillä voimme poistaa tämän tarjouksen milloin tahansa.',
  forYour: 'Sinun',
  privacy: 'yksityisyytesi',
  youAreBilled: 'sinua laskutetaan',
  discreetly: 'hienovaraisesti',
  as: 'nimellä',
  specialOffer: 'Erikoistarjous',
  membershipInfo: 'Jäsenyyden Tiedot',
  // Success Upgrade
  successUpgrade: 'Korotus Onnistui',
  welcomeToVip: 'Tervetuloa VIP-jäseneksi!',
  youHaveSuccessfullyUpgraded: 'Olet onnistuneesti korottanut',
  vipPremiumMembership: 'VIP Premium Jäseneksi',
  importantInfo: 'Tärkeää tietoa!',
  pleasePrintThisPage:
    'Tulosta tämä sivu tai kirjoita seuraavat tiedot muistiin. Tarvitset tätä jatkossa päästäksesi näkemään tai muuttaaksesi jäsenyystietojasi.',
  yourCreditCardBilled:
    'Luotto-/maksukorttisi laskutetaan hienovaraisesti nimellä',
  yourPayPalCardBilled: 'PayPal -tiliäsi laskutetaan hienovaraisesti nimellä',
  youWillBeDicreetlyBilled: 'Sinua laskutetaan hienovaraisesti nimellä:',
  membershipPurchased: 'Jäsenyys Ostettu:',
  billingTerms: 'Laskutusehdot:',
  vipPremium: 'VIP Premium',
  total: 'Yhteensä',
  vip: 'VIP',
  trial: 'Koeaika',
  yourInfo: 'Sinun Tietosi:',
  fullName: 'Koko Nimi:',
  pleaseContactSupport:
    'Ole hyvä ja ota yhteyttä asiakaspalveluun jos sinulla on laskutusta koskevia kysymyksiä',
  billingSupport: 'Laskutuksen Asiakaspalvelu:',
  billingPhone: 'Laskutuksen Puhelinnumero:',
  clickToAccessVip: 'Näpäytä VIP palveluihin',
  tapToAccessVip: 'Näpäytä päästäksesi VIP palveluihin',
  thirtyDays: '30 päivää',
  // Process Payment
  processPayment: 'Ole hyvä ja odota, me suoritamme maksuasi...',
  paymentProcessingError: 'Virhe Maksun Suorituksessa!',
  // Error Component
  serviceUnavailable: 'Palvelu väliaikaisesti pois käytöstä',
  pleaseTryLater: 'Ole hyvä ja yritä myöhemmin uudelleen',
  // Another Client
  isOpenInAnotherWindow:
    'on auki toisessa ikkunassa. Voit sulkea tämän ikkunan.',
  useInThisWindow: 'Käytä tässä ikkunassa',
  // modal alert merging
  greatNews: 'Hyviä Uutisia,',
  weAreHappy: ' Ilmoitamme ilolla, että alkaen tänään, ',
  become:
    '{old_site} ja {new_site} ovat yhdistyneet yhdeksi suureksi sivustoksi: {new_site}! ',
  thisMeans:
    ' Tämä tarkoittaa suurempaa yhteisöä kaikille jäsenillemme, enemmän osumia ja parempia mahdollisuuksia löytää se oikea.',
  dontWorry:
    'Älä huoli, sinulle, jäsenemme, mikään ei muutu. Kirjautumistietosi, profiilitietosi ja historiasi on siirretty automaattisesti, joten voit jatkaa siitä, mihin jäit. ',
  // ads
  ad: 'Mainos',
  sponsored: 'MAKSETTU',
  findNiche: 'Hae' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  meetNiche:
    'Tapaa' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  // ads random text, this is generated like this for easy transition to another niche
  adsRandomTextMeetNiche:
    'Tapaa ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextSingleNiche:
    'Sinkku' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextFindNiche:
    'Hae' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextDateNiche:
    'Treffi ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextNicheRomance:
    config.NICHE_SINGULAR.replace(/\w/, (c) => c.toUpperCase()) + ' Romanssi',
  adsRandomTextLonelyNiche:
    'Yksinäinen ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextNicheLove:
    config.NICHE_SINGULAR.replace(/\w/, (c) => c.toUpperCase()) + ' Rakkaus',
  adsRandomTextWhantNiche:
    'Haluan' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()) + '?',
  adsRandomTextNicheDates:
    config.NICHE_SINGULAR.replace(/\w/, (c) => c.toUpperCase()) + ' Deittejä',
  adsRandomTextMoreNiche:
    'Enemmän' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextSearchNiche:
    'Etsi' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextNicheNow:
    config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()) + ' Nyt?',
  adsRandomTextNichesingles:
    config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()) + ' Sinkut',
  // niche gender names
  genderTsTvTg: 'TS/TV/TG',
  genderXdresser: 'Ristiin\u00ADpukeutuja',
  genderCouple: 'Pariskunta',
  genderDom: 'Domina\u00ADtar',
  genderFem: 'Femdom',
  genderBiCouple: 'Bi Pariskunta',
  genderSugarMale: 'Sokeri-Beibe Mies',
  genderSugarBaby: 'Sokeri-Beibe',
  genderHotWife: 'Kuumavaimo/\n\u00ADPariskunta',
  genderMan: 'Mies',
  lookingFor: 'etsin',
  genderMilf: 'MILF',
  // onboarding
  moreInformation:
    'lisätäänpä hieman enemmän tietoja sinusta jotta voimme löytää muita sinkkuja jotka ovat sopivia osumaksesi',
  howTallAreYou: 'Kuinka pitkä olet?',
  UseSliderHeight: 'Käytä mittaria ilmoittaaksesi pituutesi',
  WhatIsYourEthnicity: 'Mikä on etninen taustasi?',
  specifyYourBodyType: 'Ole hyvä ja tarkenna vartalotyyppisi',
  whatYouLookingFor: 'Kerro meille täydellisestä osumastasi',
  idealMatchesAge: 'Mikä on ideaali osumasi ikä',
  howFarAway:
    'Kuinka kauas olet valmis matkustamaan tavataksesi täydellisen osumasi?',
  useSliderDistance: 'Käytä mittaria tarkentaaksesi pituus',
  toHaveYourProfile: 'Kerro muille käyttäjille itsestäsi...',
  writeSomethingAboutYourself:
    'Kirjoita itsestäsi jotain mielenkiintoista, jotain, joka kuvaa sinua parhaiten',
  uploadAPhoto: 'Lataa valokuva',
  thisIsImportant: 'Tämä on profiilisi tärkein ominaisuus!',
  youOnlyHave: 'Sinulla on vain 1 mahdollisuus tehdä ensivaikutelma.',
  tipPhoto:
    'Vinkki: Kuvien tulisi olla otettu viime aikoina, niissä tulee esiintyä vain sinä, ja muista välitä kuva joka edustaa parhaita puoliasi!',
  iUploadLater: 'Lataan kuvan myöhemmin...',
  congratulations: 'Onneksi olkoon...',
  yourProfileUpdated:
    'Profiilisi on päivitetty ja olet askeleen lähempänä täydellisen osumasi löytämistä.',
  specialOfferNewMembers:
    'Tarjoamme uusille jäsenille erikoistarjouksena ilmaisen kokeilujakson.',
  get25OffNow: 'Saa 25% alennusta!',
  youWillBeRedirected: 'sinut ohjataan korotussivulle',
  seconds: 'sekuntia',
  aNewMember: 'Uutena jäsenenä olet oikeutettu',
  get: 'saamaan',
  initialOff: '25% hinnasta pois',
  selectedMembership: 'sinun valittu jäsenyytesi',
  selectYourMembership: 'Valitse jäsenyys vaihtoehtosi',
  newPrice: 'Uusi Hinta',
  oldPrice: 'Vanha Hinta',
  iDontWantToPayLess: 'Ei kiitos, en halua maksaa vähemmän.',
  addPhotoOnboarding: 'Lisää Kuva',
  uploadAnotherPhoto: 'Lataa toinen kuva',
  finish: 'Viimeistele',
  ifYourDoneUploadingPhotos: 'Jos olet valmis kuvien lataamisen kanssa',
  // california
  CCPATitle: 'Älä myy henkilökohtaisia tietojani',
  CCPAPersonal: 'Henkilökohtaisia tietojani',
  youHaveAlreadyOptedOut: 'Olet jo kieltäytynyt.',
  // TransactionProgress
  transactionProgress: 'Tapahtuman Prosessointi',
  checkingSpecialOffers: 'Etsitään erikoistarjouksia...',
  initializingTransaction: 'Viimeistellään tapahtumaa...',
  // SpecialOffer
  congratulationsSpecialOffer: 'Onneksi olkoon!',
  youAreQualified: 'Olet oikeutettu erikoistarjoukseen!',
  toAcceptThisOffer: 'Hyväksyäksesi tämän tarjouksen, näpäytä Jatka alta:',
  noThanksIDontWant: 'Ei kiitos, en halua maksaa vähemmän.',
  forYourConvenience:
    'Helpottaaksemme prosessiasi, sinua laskutetaan uudelleen',
  on: 'päivämääränä',
  andEvery: 'ja joka',
  daysThereafter: 'sen jälkeen kunnes tilaus peruutetaan.',
  off: 'pois',
  yourSelectedMembership: 'valitsemasi jäsenyys.',
  // Transaction Declined
  transactionDeclined: 'Tapahtuma Hylätty',
  yourCreditCardWasNotApproved:
    'Luottokorttiasi ei hyväksytty erikoistarjoukseemme.',
  butWait: 'mutta ODOTA... tässä on toinen erikoistarjous',
  tryA: 'Kokeile',
  forOnly: 'hintaan vain',
  acceptOffer: 'Hyväksy Tarjous',
  membership: 'Jäsenyys',
  // Measure System
  measureSystem: 'Mittayksikkö',
  imperial: 'Imperiaali',
  metric: 'Metri',
  // kink cam banner
  viewNow: 'Katso Nyt',
  youGotAFree: 'Sinulla on ilmainen',
  // receipt page
  bonusMembership: 'Bonus Jäsenyys',
  membersLoginArea: 'Käyttäjien Kirjautuminen',
  // language
  language: 'Kieli',
  // OneClick
  signInFromReferal: 'Kirjaudu sisään profiilistasi toisella sivustolla',
  siteWouldLikeToAccess:
    config.TITLE +
    ' haluaa saada seuraavat tiedot rekisteröidäkseen sinut tällä sivustolla:',
  permissionsToAccess:
    'Nimi, sähköposti, syntymäaika, sijainti ja Treffiprofiilin perustiedot',
  iConsentToDetailsAndRegister:
    'Hyväksyn, että näitä tietoja käytetään profiilini rekisteröimiseen ja vahvistan hyväksyväni ',
  allow: 'Salli',
  byClickingAllow:
    'Valitsemalla SALLI annat suostumuksesi siihen, että ' +
    config.TITLE +
    ' käyttää näitä tietoja rekisteröidäksesi sinut treffisivustolle ja vahvista, että hyväksyt alla olevat käyttöehdot. Vaihtoehtoisesti voit käyttää meidän ',
  standardRegistrationForm: 'tavallinen rekisteröintilomake',
  // SpecialOffer2x
  getFreeMembership: 'Hanki ILMAINEN jäsenyys osoitteessa {0}',
  doubleYourChances: 'Tuplaa mahdollisuutesi tavata joku',
  weHavePartnered:
    'Olemme yhteistyössä yrityksen {0} kanssa auttaaksemme lisäämään jäsentemme mahdollisuuksia löytää ottelu. Kun napsautat yllä olevaa painiketta, luomme automaattisesti 100% ILMAISEN PROFIILIN osoitteessa {0} ja ohjaamme sinut jäsenalueelle, jotta voit alkaa etsiä mahdollisia osumia heidän tietokannastaan.',
  congratulationsYouGotFree:
    'Onnittelut, sait ILMAISEKSI jäsenyyden osoitteessa {site_name}.',
  toGetLoggedInto: ' kirjautuaksesi sivustolle.',
  // RefundCreditCard
  refundCreditCard: 'Hyvitys uudella luottokortilla',
  refundCreditCardSuccess: 'Hyvityspyyntösi on lähetetty onnistuneesti.',
  // Nearby Connect
  nearbyConnect: 'Nearby Connect',
  nearbyDecline: 'Ei kiitos, en halua lähettää sitä nyt, teen sen myöhemmin.',
  introduceMyself: 'Esitellä itseni',
  distance: 'Etäisyys',
  anyDistance: 'Mikä tahansa etäisyys',
  message: 'Viesti',
  sentByNearbyConnect: 'Lähettäjä NearbyConnect',
  typeYourMessageHere: 'Kirjoita viestisi tähän',
  sendThisToMyNewMatches:
    'Lähetä tämä myös kaikille uusille otteluille niiden liittyessä',
  successNearbyConnect: 'Nearby Connectin määrittäminen onnistui',
  nearbyConnectTitle:
    'Ota välittömästi yhteyttä satoihin jäseniin! Vain profiiliasi vastaavat käyttäjät saavat nämä viestit. Aloita kirjoittamalla viestisi alle:',
  nearbyConnectAlert:
    'Nearby Connect -viestit ovat ainutlaatuisia viestejä muilta todellisilta jäseniltä, jotka voivat olla täydellinen parisi. Nämä viestit lähetetään automaattisesti vain käyttäjille, jotka vastaavat kyseistä käyttäjäprofiilia',
  nearbyUnavailable:
    'Valitettavasti NearbyConnect-ominaisuus ei ole tällä hetkellä käytettävissä. Tätä ominaisuutta voidaan käyttää kerran 30 päivässä. Kiitos ymmärryksestäsi.',
  nearbyFeatureUsed: 'Käytit NearbyConnect-ominaisuutta {date}.',
  toKeepNearbyFree:
    'Jotta NearbyConnect pysyy maksuttomana, rajoitamme sen vain yhteen esittelyyn 30 päivän välein.',
  ifYouLikeToBeIntroduced:
    'Jos haluat, että sinut esitellään useammalle jäsenelle, palaa hintaan {date}.',
  nearbyConnectValentineTitle: 'Ystävänpäivä erikois',
  nearbyConnectValentineText1:
    'Ystävänpäivä lähestyy. Rajoitetun ajan annamme sinun lähettää a ',
  nearbyConnectValentineText2: 'ILMAINEN esittelyviesti ',
  nearbyConnectValentineText3:
    'sadoille käyttäjille, jotka vastaavat mieltymyksiäsi. Aloita kirjoittamalla viestisi alle:',
  // subscription status
  subscriptionStatus: 'Subscription Status',
  subscritpionStatusManageLink1:
    'Onnittelut! Olet VIP-jäsen. Ole hyvä ja vieraile ',
  subscritpionStatusManageLink2: ' hallita tilaustasi.',
  subscriptionUpgradeLink1: 'Olet perusjäsen. ',
  subscriptionUpgradeLink2: 'Päivitä VIP-palveluun nyt!',
  // Manage Nearby Connects
  manageNearbyConnects: 'Hallinnoi Nearby Connectia',
  sendNewNearbyConnectMessage: 'Lähetä uusi NearbyConnect-viesti',
  activeUntil: 'Aktiivinen asti',
  sendToNewJoins: 'Lähetä uusiin liittymiin',
  update: 'Päivittää',
  disable: 'Poista käytöstä',
  nearbyConnectUpdated: 'Nearby Connect päivitetty onnistuneesti',
  nearbyConnectWillBeAvailable:
    'Nearby Connect on käytettävissäsi seuraavan kerran ',
  canChangeMessageOn: 'Viestiä voi vaihtaa',
  getInTouchWith:
    'Ota välittömästi yhteyttä satoihin jäseniin! Vain profiiliasi vastaavat käyttäjät saavat nämä viestit.',
  cookieConsentText:
    'Tämä sivu käyttää evästeitä. Jatkamalla eteenpäin sivuille hyväksyt sivujen evästeiden käytön.',
  cookieConsentDetailsLinkText: 'Tiedot',
  cookieConsentButtonText: 'Ymmärrän',
  cookieConsentDeclineButtonText: 'sulje',
};



// WEBPACK FOOTER //
// ./src/assets/localization/fi.js